import { createSelector } from 'reselect';

const dashboardData = (state) => state.dashboardData;

export const selectDashboardConfig = () =>
  createSelector([dashboardData], (state) => state.dashboardConfig);

export const selectDashboardTablesData = () =>
  createSelector([dashboardData], (state) => state.dashboardTablesData);
